import { useEffect, useMemo, useState } from 'react';

export function usePagination<T>(rows: T[], enabled: boolean, rowsPerPage: number) {
  const [page, setPage] = useState(0);

  const totalPages = Math.ceil(rows.length / rowsPerPage);

  useEffect(() => {
    if (page > 0 && totalPages > 0 && page >= totalPages) {
      setPage(0);
    }
  }, [totalPages]);

  const pagedRows = useMemo(() => {
    if (!enabled) return rows;
    const start = page * rowsPerPage;
    return rows.slice(start, start + rowsPerPage);
  }, [rows, page, rowsPerPage, enabled]);

  return {
    pagedRows,
    page,
    setPage,
    totalPages,
    isFirst: page === 0,
    isLast: page >= totalPages - 1
  };
}
